import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PortalShell } from '@/shared/patterns/AppShell';
import { retailAdminNav, RETAIL_ADMIN_PORTAL_TITLE } from '@/domains/retail';
import { requirePortal } from '@/app/entry/portalGuards';

// Layout del Portal Admin VentasLuga: sidebar del dominio + topbar. Sin este archivo las pantallas
// hijas se renderizarían sueltas, sin menú.
export const Route = createFileRoute('/_backoffice/retail-admin')({
    beforeLoad: ({ context }) => requirePortal(context.auth, 'retail-admin'),
    component: () => (
        <PortalShell title={RETAIL_ADMIN_PORTAL_TITLE} nav={retailAdminNav}>
            <Outlet />
        </PortalShell>
    ),
});
